import { useAppSelector } from 'store/store';
import { Permission } from 'types/enums/Permission';

export const usePermissions = () => {
  const user = useAppSelector((state) => state.auth.user);
  const permissions = (user?.permissions ?? []).map(Number);

  const hasPermission = (permission: Permission): boolean =>
    permissions.includes(Permission.SUPER_ADMIN) || permissions.includes(permission);

  const isAdmin = () => hasPermission(Permission.ADMIN);
  const isSuperAdmin = () => permissions.includes(Permission.SUPER_ADMIN);
  const isRedakteur = () => hasPermission(Permission.REDAKTEUR);
  const isFreigeber = () => hasPermission(Permission.FREIGEBER);

  return { hasPermission, isAdmin, isSuperAdmin, isRedakteur, isFreigeber };
};
